module.exports = __webpack_public_path__ + "media/dashboard/assets/images/task_mask_img-b51e888e8467d09195d7ee4b4b253230.png";